import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { AUTH_URL } from "../../../utils/constants";
import { useAuth } from "../../../utils/AuthContext";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState({ email: "", password: "" });
  const { login } = useAuth();
  const [user, setUser] = useState("user");
  const [showPassword, setShowPassword] = useState(false);

  const loginUser = (response) => {
    const userData = {
      email: email,
      userId: response?.data?.id,
      name: response?.data?.name,
      role: response?.data?.role,
    };
    login(userData);
    navigate("/botDesk");
  };

  const handleValidation = () => {
    let isValid = true;
    let newError = { email: "", password: "" };

    if (!email.trim()) {
      newError.email = "Email is required.";
      isValid = false;
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      newError.email = "Please enter a valid email address.";
      isValid = false;
    }

    if (!password.trim()) {
      newError.password = "Password is required.";
      isValid = false;
    }

    setError(newError);
    return isValid;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      try {
        if (user === "officer") {
          const response = await axios.post(
            `${AUTH_URL}expertlogin`,
            { email: email, password: password },
            { headers: { "Content-Type": "application/json" } }
          );
          if (response?.data) {
            const userData = {
              email: response.data.email || email,
              userId: response.data.id,
              name: response.data.name,
              role: "officer",
              category: response.data.officer_cag_category || "Ministry of Women and Child Development",
            };
            login(userData);
            navigate("/officerDesk");
            return;
          }
        } else if (user === "admin") {
          const response = await axios.post(
            `${AUTH_URL}adminlogin`,
            { email: email, password: password },
            { headers: { "Content-Type": "application/json" } }
          );
          if (response?.data) {
            const userData = {
              email: response.data.email || email,
              userId: response.data.id,
              name: response.data.name,
              role: "admin",
            };
            login(userData);
            navigate("/adminDesk");
            return;
          }
        } else {
          const response = await axios.post(
            `${AUTH_URL}usersignin`,
            { email: email, password: password },
            { headers: { "Content-Type": "application/json" } }
          );
          if (response?.data) {
            loginUser(response);
            return;
          }
        }
      } catch (error) {
        console.log("Error in login api", error);
        Swal.fire({
          icon: "error",
          title: "Authentication Failed",
          text: error.response?.data?.message || "Invalid credentials or login service unavailable."
        });
      }
      setError({ email: "", password: "" });
    }
  };

  return (
    <div className="flex flex-col flex-1 items-center justify-center p-4 relative min-h-[calc(100vh-140px)] bg-gradient-to-br from-[#ffffff] via-[#f7eef0] to-[#fbeef1]">
      {/* Site-wide animated water backdrop */}
      <div className="water-backdrop" aria-hidden="true">
        <svg className="wave-back" viewBox="0 0 2400 220" preserveAspectRatio="none">
          <path fill="#9c2942" fillOpacity="0.06" d="M0,180 Q100,60 200,180 Q300,60 400,180 Q500,60 600,180 Q700,60 800,180 Q900,60 1000,180 Q1100,60 1200,180 Q1300,60 1400,180 Q1500,60 1600,180 Q1700,60 1800,180 Q1900,60 2000,180 Q2100,60 2200,180 Q2300,60 2400,180 L2400,220 L0,220 Z" />
        </svg>
        <svg className="wave-front" viewBox="0 0 2400 180" preserveAspectRatio="none">
          <path fill="#4a0e1e" fillOpacity="0.045" d="M0,140 Q150,40 300,140 Q450,40 600,140 Q750,40 900,140 Q1050,40 1200,140 Q1350,40 1500,140 Q1650,40 1800,140 Q1950,40 2100,140 Q2250,40 2400,140 L2400,180 L0,180 Z" />
        </svg>
      </div>
      
      <div className="w-full max-w-[460px] bg-white rounded-[18px] shadow-[0_10px_30px_rgba(74,14,30,0.15)] overflow-hidden z-10 border-t-[4px] border-[#9c2942] relative">
        <div className="px-[40px] py-[32px]">
          <div className="text-center mb-[24px]">
            <h1 className="text-[28px] font-heading font-[800] text-[#300a14] mb-[6px]">Identity Authentication</h1>
            <p className="text-[#4c6478] text-[14.5px]">Select your portal to begin the secure session.</p>
          </div>
          
          <div className="flex bg-[#faf1f2] p-[6px] rounded-[12px] mb-[24px] relative">
            <div className={`absolute top-[6px] bottom-[6px] w-[calc(33.333%-8px)] bg-[#7a1830] rounded-[8px] shadow-[0_2px_12px_rgba(74,14,30,0.07)] transition-all duration-400 ease-[cubic-bezier(0.2,1,0.2,1)] z-[1]`} 
                 style={{ left: user === 'user' ? '6px' : user === 'officer' ? 'calc(33.333% + 2px)' : 'calc(66.666% - 2px)' }}></div>
            
            <button 
              type="button"
              className={`flex-1 text-center py-[10px] text-[13.5px] font-[700] z-[2] transition-colors duration-300 ${user === 'user' ? 'text-white' : 'text-[#4c6478] hover:text-[#300a14]'}`}
              onClick={() => setUser('user')}
            >
              User Login
            </button>
            <button 
              type="button"
              className={`flex-1 text-center py-[10px] text-[13.5px] font-[700] z-[2] transition-colors duration-300 ${user === 'officer' ? 'text-white' : 'text-[#4c6478] hover:text-[#300a14]'}`}
              onClick={() => setUser('officer')}
            >
              Officer Login
            </button>
            <button 
              type="button"
              className={`flex-1 text-center py-[10px] text-[13.5px] font-[700] z-[2] transition-colors duration-300 ${user === 'admin' ? 'text-white' : 'text-[#4c6478] hover:text-[#300a14]'}`}
              onClick={() => setUser('admin')}
            >
              Admin Login
            </button>
          </div>
          <form onSubmit={handleLogin} className="flex flex-col">
            <div className="mb-[16px]">
              <label className="block text-[14px] font-[700] text-[#300a14] mb-[6px]">Email ID <span className="text-[#e0433a]">*</span></label>
              <input
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`w-full px-[14px] py-[12px] rounded-[10px] border-[1.5px] ${error.email ? 'border-red-500 bg-red-50' : 'border-[#e8d3d8] bg-white'} focus:outline-none focus:border-[#9c2942] text-[15px] text-[#10293d] transition-all`}
              />
              {error.email && <p className="text-red-500 text-xs mt-1.5 font-medium">{error.email}</p>}
            </div>
            
            <div className="mb-[16px]">
              <label className="block text-[14px] font-[700] text-[#300a14] mb-[6px]">Password <span className="text-[#e0433a]">*</span></label>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`w-full px-[14px] py-[12px] rounded-[10px] border-[1.5px] ${error.password ? 'border-red-500 bg-red-50' : 'border-[#e8d3d8] bg-white'} focus:outline-none focus:border-[#9c2942] text-[15px] text-[#10293d] transition-all`}
              />
              {error.password && <p className="text-red-500 text-xs mt-1.5 font-medium">{error.password}</p>}
              
              <div className="flex items-center mt-3">
                <input
                  type="checkbox"
                  id="showPassword"
                  checked={showPassword}
                  onChange={(e) => setShowPassword(e.target.checked)}
                  className="w-4 h-4 text-[#9c2942] bg-white border-[#e8d3d8] rounded cursor-pointer"
                />
                <label htmlFor="showPassword" className="ml-2 text-sm text-[#4c6478] font-[600] cursor-pointer">
                  Show password
                </label>
              </div>
            </div>
            
            <button 
              type="submit" 
              className="w-full bg-[#9c2942] text-white font-[700] text-[16px] p-[14px] rounded-[12px] shadow-[0_10px_30px_rgba(74,14,30,0.15)] mt-[8px] hover:bg-[#7a1830] transition-colors duration-300"
            >
              Log In
            </button>
            
            <button 
              type="button"
              onClick={() => navigate("/register")}
              className="w-full bg-[#f7eef0] text-[#9c2942] font-[700] text-[15px] p-[14px] rounded-[12px] border border-[#e8d3d8] mt-[12px] hover:bg-[#fbeef1] transition-colors duration-300"
            >
              New User? Sign Up
            </button>
          </form>
          
          <p className="text-center text-[12.5px] text-[#7c93a3] mt-[20px] font-medium">By signing in, you accept the Terms and Conditions.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
